module.exports = __webpack_public_path__ + "static/media/white-logo.d4e8fa12.svg";